import { EnumSignture, KeydrivePlan } from "./UserModel";

export interface Organization extends OrganizationCreate{
  id?: string;
  d4SignSafeBox?: string;
  allowDrive:boolean;
  contractId?: string;
  resource?: number;
  serviceUserId?: string;
  contractStatus?: number;
  contractUsersResourceQuantity?: number;
  adminUsers?: string[]
  workspaceQuantity?: number;
}

export interface IAcceptMigrationUser {
  internalName: string;
  userId: string;
}

export interface OrganizationSigntureInformation {
  userLogin: string;
  contractId: string;
  contractedPlan: KeydrivePlan;
  allOrganizationUsers: OrganizationUserVO[];
  currentPlan: KeydrivePlan;
  signture: EnumSignture;
  cancelAt?: string;
  canceledAt?: string;
  failedPaymentAttempts: number;
  planName: string;
  contractDowngradeUpgrade: ContractDowngradeUpgrade;
}

export interface ContractDowngradeUpgrade {
  contractAlreadyDowngradedOrUpgraded: boolean;
  whenUpgradeOrDowgrade: string;
  whenCanUpgradeOrDowngradeAgain: string;
}

export interface IUpgradePlan {
  email: string;
  internalName: string;
  newPriceId: string;
}

export interface IDowngradePlan {
  email: string;
  internalName: string;
  newPriceId: string;
  newPlan: KeydrivePlan;
}

export interface IConfirmationDowngradeUpgrade {
  email: string;
  confirmationPassword: string;
}

export interface IBatchDeleteReturn {
  deletedItemsId: AllDeletedItemsAttempt[];
  itemsWithErrors: DeletedItemsWithErrors[];
  itemsDeletedSuccesfully: DeletedItemsSuccessFully[];
}

export interface DeletedItemsSuccessFully {
  itemName: string;
  fileExtension: string;
  itemId: string;
}

export interface AllDeletedItemsAttempt {
  itemName: string;
  itemId: string;
  fileExtension: string;
}

export interface DeletedItemsWithErrors {
  errorReason: string;
  itemName: string;
  itemId: string;
  fileExtension: string;
}

export interface OrganizationUserVO {
  userLogin: string
  userId: string;
  organizationId: string;
  permission: OrganizationPermission;
}

export enum OrganizationPermission {
  ADMIN = 0,
  NORMAL,
  GUEST
}

export interface IDeclineMigrationUser {
  internalName: string;
  userId: string;
}


export interface OrganizationCreate {
  name?: string;
  internalName?:string;
  loginType?: number;
}

export interface User {
  id: string;
  name: string;
  login: string;
  phone: string;
  groups: string[];
  isGuest: boolean;
}

export type AdminUserVO = {
  name: string;
  email: string;
  userLoggedIsNotAdmin: boolean;
}

export interface D4SignSafeBox {
  uuidSafe: string;
  nameSafe: string;
}

export interface SetD4SignModel {
  organizationId: string;
  d4SignSafeBox: string;
}

export interface OrganizationNameVO{
  organizationId: string;
  organizationName: string;
}

export interface OrganizationUserServiceVO{
  organizationId: string;
  serviceUserId: string;
}

export interface IReturnAllSizes {
  hasContract: boolean;
  sizeOrganizations: ISizeOrganization[];
  totalResouce: IStorageTypes;
}

export interface ISizeOrganization {
  idOrganization?: string;
  nameOrganization?: string;
  size: IStorageTypes;
  workspaces: ISizeWorkspace[];
}

export interface ISizeWorkspace {
  idWorkspace: string;
  nameWorkspace: string;
  size: IStorageTypes;
}

export interface IStorageTypes {
  storageArchiveUseTotal: number;
  storageAzureUseTotal: number;
  storageUseTotal: number;
}